import { OccupancyType } from '@keaze/web/common/enums';
import { Facet } from '@keaze/web/common/interfaces';
import { FilterValue } from '@keaze/web/components/filters';

export type FilterProps = {
  facets: Facet[];
  isLoading: boolean;
  withoutParams?: boolean;
  withOnlyLocationData?: boolean;
  className?: string;
  onChange: (filters: FiltersState) => void;
};

export enum SearchFilters {
  OccupancyType = 'occupancy_type',
  Location = 'location',
  Radius = 'radius',
  MaxPrice = 'max_full_value',
  MaxSpend = 'max_monthly_spend',
  Bedrooms = 'bedrooms',
  PropertyType = 'types',
  ParkingType = 'parking',
  Schemes = 'schemes',
  Status = 'status',
  NewHomes = 'new_homes',
  Bathrooms = 'bathrooms',
  Parking = 'parking',
  OtherFeatures = 'other_features',
  MyDepositBudget = 'max_deposit',
  MaxMonthlyRent = 'max_monthly_rent',
}

export enum MultiFilters {
  More = 'more',
  Mobile = 'mobile',
}

export type FiltersState = Record<SearchFilters, FilterValue>;

export type StoredFiltersState = Omit<FiltersState, 'location'>;

export type StoredFilters = {
  location: string;
  [OccupancyType.Sale]: StoredFiltersState;
  [OccupancyType.Rent]: StoredFiltersState;
};

export interface MobileFiltersData extends Facet {
  value: string | number | number[] | null;
}

export type OnFiltersChange = (filters: FiltersState) => void;
